import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=4c65d14f&scoped=true&"
import script from "./Breadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./Breadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=4c65d14f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c65d14f",
  null
  
)

export default component.exports